module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "close__btn",
    class: _vm.classes
  }, [_c('svg', {
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink",
      "width": "64px",
      "height": "64px"
    },
    on: {
      "click": function($event) {
        _vm.pushTheButton()
      },
      "mouseenter": function($event) {
        _vm.onMouseEnter()
      },
      "touchstart": function($event) {
        _vm.onMouseEnter()
      },
      "mouseleave": function($event) {
        _vm.onMouseLeave()
      },
      "touchend": function($event) {
        _vm.onMouseLeave()
      }
    }
  }, [_c('defs', [_c('filter', {
    attrs: {
      "filterUnits": "userSpaceOnUse",
      "id": "Filter_0",
      "x": "0px",
      "y": "0px",
      "width": "64px",
      "height": "64px"
    }
  }, [_c('feOffset', {
    attrs: {
      "in": "SourceAlpha",
      "dx": "0",
      "dy": "0"
    }
  }), _vm._v(" "), _c('feGaussianBlur', {
    attrs: {
      "result": "blurOut",
      "stdDeviation": "3"
    }
  }), _vm._v(" "), _c('feFlood', {
    attrs: {
      "flood-color": "rgb(0, 0, 0)",
      "result": "floodOut"
    }
  }), _vm._v(" "), _c('feComposite', {
    attrs: {
      "operator": "atop",
      "in": "floodOut",
      "in2": "blurOut"
    }
  }), _vm._v(" "), _c('feComponentTransfer', [_c('feFuncA', {
    attrs: {
      "type": "linear",
      "slope": "0.26"
    }
  })], 1), _vm._v(" "), _c('feMerge', [_c('feMergeNode'), _vm._v(" "), _c('feMergeNode', {
    attrs: {
      "in": "SourceGraphic"
    }
  })], 1)], 1)]), _vm._v(" "), _c('path', {
    staticClass: "circle-shadow",
    attrs: {
      "filter": "url(#Filter_0)",
      "fill-rule": "evenodd",
      "fill": "rgb(255, 255, 255)",
      "d": "M31.500,10.000 C43.374,10.000 53.000,19.626 53.000,31.500 C53.000,43.374 43.374,53.000 31.500,53.000 C19.626,53.000 10.000,43.374 10.000,31.500 C10.000,19.626 19.626,10.000 31.500,10.000 Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "circle",
    attrs: {
      "fill-rule": "evenodd",
      "fill": "rgb(255, 255, 255)",
      "d": "M31.500,10.000 C43.374,10.000 53.000,19.626 53.000,31.500 C53.000,43.374 43.374,53.000 31.500,53.000 C19.626,53.000 10.000,43.374 10.000,31.500 C10.000,19.626 19.626,10.000 31.500,10.000 Z"
    }
  }), _vm._v(" "), _c('g', {
    staticClass: "cross",
    attrs: {
      "transform": "translate(22.5,23.5)"
    }
  }, [_c('path', {
    attrs: {
      "fill-rule": "evenodd",
      "fill": "rgb(255, 54, 0)",
      "d": "M16.574,13.654 L13.991,16.236 L8.501,10.750 L3.012,16.236 L0.429,13.654 L5.918,8.169 L0.429,2.683 L3.012,0.101 L8.501,5.587 L13.991,0.101 L16.574,2.683 L11.085,8.169 L16.574,13.654 Z"
    }
  })])])])
},staticRenderFns: []}


/*****************
 ** WEBPACK FOOTER
 ** ./~/vue-loader/lib/template-compiler.js?id=data-v-c8a4dd68!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/UI/CloseButton.vue
 ** module id = 756
 ** module chunks = 2
 **/